@let fonts = fontStore.fonts;
@if (fontStore.isLoading()) {
  <div class="pt-32">
    <aw-loading-animation></aw-loading-animation>
  </div>
}
@if (fonts() && ngControl.control! && !fontStore.isLoading()) {
  <aw-drop-down
    [id]="id()"
    [label]="label()"
    [options]="fonts()"
    name="name"
    [formControl]="ngControl.control! | toFormControl"></aw-drop-down>
}
